// src/components/store/sections/hero-banner/HeroV65BentoshowcaseIndigoPulse.tsx
"use client";

import React from "react";
import DynamicHeroVariant from "./DynamicHeroVariant";

export default function HeroV65BentoshowcaseIndigoPulse(props: any) {
  return (
    <DynamicHeroVariant
      variantNumber={65}
      archKey="bento_showcase"
      archLabel="Bento Multi-Tile Hero"
      palName="IndigoPulse"
      grad="from-indigo-500 via-blue-600 to-violet-700"
      lightBg="bg-indigo-50"
      textCol="text-indigo-700"
      borderCol="border-indigo-200"
      btnCls="bg-indigo-600 hover:bg-indigo-700"
      {...props}
    />
  );
}
